import { NameInput } from './NameInput';
export default NameInput;
